@if (futurePayments$ | async; as futurePayments) {
  <div class="row pad-top-20">
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <h1
        dsContent
        [contentPath]="'policy.premiumBilling.futurePaymentPageHeading'"
        class="font-weight-bold"
      ></h1>
      <p
        dsContent
        class="pad-top-20"
        [contentPath]="
          futurePayments && futurePayments.length === 1
            ? 'policy.premiumBilling.futurePaymentPageBody.term'
            : 'policy.premiumBilling.futurePaymentPageBody.monthly'
        "
      ></p>
    </div>
    <amfam-payment-schedule
      [payments]="futurePayments$ | async"
      [feature]="vehicleFeatures.REPLACE_VEHICLE"
    ></amfam-payment-schedule>
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <p
        dsContent
        [contentPath]="'policy.premiumBilling.futurePaymentsDisclaimer'"
        class="font-size-0-75"
      ></p>
    </div>
    <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
      <hr aria-hidden="true" class="fill" />
      <call-to-action
        [displayBackButton]="true"
        tertiaryButtonName="Cancel"
        primaryButtonName="Replace Vehicle"
        (primaryEvent)="replaceVehicle()"
        secondaryButtonName="send to my agent"
        (secondaryEvent)="sendToAgent()"
        (tertiaryEvent)="cancel()"
        (backEvent)="goBack()"
      ></call-to-action>
    </div>
  </div>
}
<ds-exit-flow-modal
  [exitFlowModalId]="exitFlowModalId"
  [isPartner]="isPartner$ | async"
  (exit)="leave()"
  (cancelModal)="stay()"
  (notifyAgent)="sendToAgent(true)"
></ds-exit-flow-modal>
